export const DEFAULT_HURDLE = "UnderwritingSummaryHurdle"; // if note created outside hurdle
